// バトル → リザルトの受け渡し（画面をまたぐ一時的な値。正本はサーバー）。
import type { BattleResult, CharId } from '@hyakki/core';
import type { FinishResponse } from '../api';

export interface ResultData {
  stageId: number;
  charId: CharId;
  difficulty: number;
  result: BattleResult;
  server: FinishResponse | null; // null = 送信できていない／ローカル試合
  local: boolean;
  error?: string;
  storyEligible?: boolean;
}
let last: ResultData | null = null;
export const setResult = (r: ResultData) => (last = r);
export const getResult = () => last;
